module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/home-property-pin-8ff4bc027ba7cb06fce09f65d2fe8851.svg";